
import { useRef, useState } from "react";
import type SliderType from "react-slick";
import SliderOrig from "react-slick";
import { CloseOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";

import './styles.scss'
import { useTranslation } from "react-i18next";

const Slider = SliderOrig as unknown as React.ComponentType<any>;

const ProductContent = ({ data, typeC }: any) => {
	const sliderRef = useRef<SliderType | null>(null);
	const [currentIndex, setCurrentIndex] = useState<number>(-1)
	const [detailData, setDetailData] = useState<any>()
	const [name, setName] = useState<string>('')
	const [email, setEmail] = useState<string>('')
	const [birtday, setBirthday] = useState<string>('')
	const [phone, setPhone] = useState<string>('')
	const [tag, setTag] = useState<string>('overview')
	const { t, i18n } = useTranslation();
	const lang = i18n.language;

	function formatDate(dateStr: string): string {
		const date = new Date(dateStr);

		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0"); // tháng bắt đầu từ 0
		const year = date.getFullYear();

		return `${day}/${month}/${year}`;
	}

	const handleShow = (index: number, dataSelect: any) => {
		if (dataSelect) {
			const test = localStorage.getItem('user')
			if (test) {
				const test1 = JSON.parse(test)
				const handleDate = test1.birthday ? formatDate(test1.birthday) : ''
				setName(test1.last_name ? test1.last_name : '')
				setBirthday(handleDate)
				setPhone(test1.phone ? test1.phone : '')
				setEmail(test1.email ? test1.email : '')
				setDetailData(JSON.parse(dataSelect))
			}
		}
		setCurrentIndex(index)
	}

	const settingSlider = {
		slidesToScroll: 4,
		centerMode: false,
		slidesToShow: 4,
		dots: false,
		arrows: true,
		fade: false,
		adaptiveHeight: true,
		infinite: false,
		speed: 400,
		swipe: true,
		draggable: true,
		slideClass: "custom",
		cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			// {
			// 	breakpoint: 376,
			// 	settings: {
			// 		slidesToShow: 1,
			// 		slidesToScroll: 1,
			// 	}
			// },
		]
		// beforeChange: (current: number, next: number) => {
		// 	console.log("beforeChange → next:", next);
		// 	sliderRef.current?.slickGoTo(next);
		// 	setCurrentIndex(next)
		// },
	}

	function replaceTemplate(str: any, data: Record<string, string | number>) {
		if (typeof str !== "string") {
			return "" // nếu null/undefined/không phải string thì trả rỗng
		}

		try {
			return str.replace(/{{(.*?)}}/g, (_, key) => {
				return data[key.trim()] !== undefined ? String(data[key.trim()]) : `{{${key}}}`
			})
		} catch (e) {
			console.error("replaceTemplate error:", e)
			return str
		}
	}


	return (
		<div className="product-content">
			<div className="main-slider">
				{data.length > 0 && <Slider {...settingSlider} className="force-left">
					{data.map((item: any) => (
						<div key={item.id}>
							<div
								onClick={() => handleShow(item.id, item.introduction)}
								className={`slider-container ${currentIndex === item.id ? 'selected' : ''} ${currentIndex !== -1 ? 'height-154' : ''}`}
								style={{
									backgroundImage: `url(${item.image?.[lang] || item.image_url})`,
								}}
							>
								<div className={`bg-content ${currentIndex === item.id ? 'selected' : ''}`}>
									<div className="content">
										<span className="title">{item.title}</span>
										<span className="sub-title">{item.subtitle}</span>
										<div className="btn-arrow">
											<img src="./images/icon_arrow.png" alt="icon" />
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</Slider>}
				{data.length === 0 && typeC === 1 && <p>{t('NoProductChoice')}</p>}
				{data.length === 0 && typeC === 2 && <p>{t('provideDateOfBirth')}</p>}
				{/* <TestSlider data={data} handleShow={handleShow} currentIndex={currentIndex} /> */}
			</div>
			<div className="main-container">
				<div className={`header-content flex justify-between px-3 product-header  py-2  ${currentIndex === -1 ? 'hidden' : ''}`}>
					<div className="flex flex-row justify-start items-center px-3 py-2 gap-4">
						<div className={`cursor-pointer border-yellow-500 text-[var(--primary-color)] ${tag === 'overview' ? 'active' : ''}`} onClick={() => setTag('overview')
						}> {t('Overview')} </div>
						<div className={`cursor-pointer border-yellow-500 text-[var(--primary-color)] ${tag === 'detail' ? 'active' : ''}`} onClick={() => setTag('detail')
						}> {t('Detail')} </div>
					</div>
					<div className="items-center  px-3 py-2" onClick={() => setCurrentIndex(-1)}>
						<CloseOutlined
							className="icon-close"
							onClick={() => setCurrentIndex(-1)}
						/>
					</div>
				</div>
				{
					tag === 'overview' && (
						data.map((item: any) => (
							<div
								key={item.id}
								className={`main-content ${currentIndex === item.id ? 'selected' : ''}`}
							>


								<div
									className="bg-main py-3"
									style={{ backgroundImage: `url(${item.banner_image})` }}
								>

									{/* <div className="product-content-header">
								<span>Over View</span>
								<CloseOutlined />
							</div> */}
									<div className="content py-10 px-8">
										<h1 className="titlev1 !text-[18px]">{item.title}</h1>
										{/* {item.introduction && <div className='contentv1' dangerouslySetInnerHTML={{ __html: JSON.parse(item.introduction).description }} />} */}
										{detailData?.map((item2: any, index: number) => {
											const replacedDescription = replaceTemplate(item2.description, { name, birtday, email, phone })

											return (
												<div key={index} >
													{/* <h3>{item2.title}</h3> */}
													<div className="!text-[14px]" dangerouslySetInnerHTML={{ __html: replacedDescription }} />
												</div>
											)
										})}
										{/* <div className='contentv1'>{item.subtitle}</div> */}
										{JSON.parse(item.description)[0] ?
											<button className="!py-2 !px-4 !text-[12px] rounded-lg">
												<Link to={`/numerologist-products/${item.id}`}>{t('viewFreeReading')}</Link>
											</button>
											:
											<button disabled className="!py-2 !px-4 !text-[12px] rounded-lg btn-disabled">{t('CommingSoon')}</button>
										}

									</div>

									<div className="wrap-img">
										<img src={`${item.image}`} loading="lazy" alt="avatar" />
									</div>
								</div>
							</div>

						))
					)
				}
				{tag === 'detail' && (
					data.map((item: any) => (
						<div
							key={item.id}
							className={`main-content ${currentIndex === item.id ? 'selected' : ''}`}
						>
							<div
								className="bg-main py-3"
								style={{ backgroundImage: `url(${item.banner_image})` }}
							>
								<div className="content pb-10 px-8">
									<h1 className="titlev1 !text-[18px] mb-4">Chi tiết báo cáo</h1>
									
									<div className="spec-table mb-6 border border-[#e6ebf1] rounded-lg overflow-hidden">
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Định dạng</span>
											<span className="v text-[#0b1c2e] font-bold">PDF tương tác</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Số trang</span>
											<span className="v text-[#0b1c2e] font-bold">24 trang</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Ngôn ngữ</span>
											<span className="v text-[#0b1c2e] font-bold">Việt / Anh</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Cập nhật</span>
											<span className="v text-[#0b1c2e] font-bold">06/2026</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Thời hạn truy cập</span>
											<span className="v text-[#0b1c2e] font-bold">Trọn đời</span>
										</div>
										<div className="spec-row flex justify-between p-3 border-b border-[#e6ebf1] text-[13px]">
											<span className="k text-[#5b6b7c]">Tác giả</span>
											<span className="v text-[#0b1c2e] font-bold">Đội ngũ LUMIR Research</span>
										</div>
									</div>

									{detailData?.map((item2: any, index: number) => {
										const replacedDescription = replaceTemplate(item2.description, { name, birtday, email, phone })
										return (
											<div key={index} className="mb-6">
												<div className="!text-[14px] text-[#33465c] leading-relaxed" dangerouslySetInnerHTML={{ __html: replacedDescription }} />
											</div>
										)
									})}

									<div className="purchase-row flex items-center gap-4 flex-wrap pt-4 border-t border-[#e6ebf1] mt-4">
										<div className="purchase-price flex flex-col">
											<span className="lbl text-[10.5px] text-[#5b6b7c] uppercase tracking-wider">Giá báo cáo</span>
											<span className="amt font-extrabold text-[20px] text-[#0b1c2e]">
												{item.point_price ? `${item.point_price.toLocaleString('vi-VN')} đ` : '249.000 đ'}
											</span>
										</div>

										{JSON.parse(item.description)[0] ?
											<button className="!py-3 !px-6 !text-[14px] mt-0 font-bold rounded-xl bg-gradient-to-r from-[#e8b93a] to-[#c9a227] text-[#241800] shadow-md flex items-center gap-2 border-none cursor-pointer">
												<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.7"/><path d="M3 9h18" stroke="currentColor" strokeWidth="1.7"/></svg>
												<Link to={`/numerologist-products/${item.id}`} className="!text-[#241800]">{t('viewFreeReading')}</Link>
											</button>
											:
											<button disabled className="!py-3 !px-6 mt-0 !text-[14px] font-bold rounded-xl btn-disabled">{t('CommingSoon')}</button>
										}

										<ul className="trust-inline !py-3 !px-6 flex items-center gap-4 text-[11.5px] text-[#5b6b7c] list-none p-0 m-0 ml-auto">
											<li className="flex items-center gap-1.5"><svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M4 12.5 9.5 18 20 6" stroke="#00a389" strokeWidth="2"/></svg>Bảo mật bởi SePay</li>
											<li className="flex items-center gap-1.5"><svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M4 12.5 9.5 18 20 6" stroke="#00a389" strokeWidth="2"/></svg>Truy cập trọn đời</li>
										</ul>
									</div>
								</div>

								<div className="wrap-img">
									<img src={`${item.image}`} loading="lazy" alt="avatar" />
								</div>
							</div>
						</div>
					))
				)}
			</div>
		</div>
	)
}
export default ProductContent;